import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
  color: #4a6bce;
  font-size: 1rem;
`;

const PageLoadFallback = () => (
  <Wrap role="status" aria-live="polite">
    Chargement…
  </Wrap>
);

export default PageLoadFallback;
